import './Tabs.scss';

import React, { ReactElement, useState } from 'react';
import classNames from 'classnames';

import { ITabProps, TabContext } from '@components/Tabs/Tab';

interface IProps {
  children: ReactElement<ITabProps> | ReactElement<ITabProps>[];
}

function Tabs({ children }: IProps) {
  const [activeIndex, setActiveIndex] = useState(0);
  const childrenList = Array.isArray(children) ? children : [children];

  const renderTab = (name: string, index: number) => {
    const className = classNames('modTabs__header__tab', {
      'modTabs__header__tab--active': index === activeIndex,
    });
    return (
      <li key={index} className={className} onClick={() => setActiveIndex(index)} role="tab">
        {name}
      </li>
    );
  };

  return (
    <div className="modTabs">
      <ul className="modTabs__header" role="tablist">
        {childrenList.map((child, i) => renderTab(child.props.name, i))}
      </ul>
      {childrenList.map((child, i) => (
        <TabContext.Provider
          key={i}
          value={{ isActive: i === activeIndex, setIsActive: () => setActiveIndex(i) }}>
          {child}
        </TabContext.Provider>
      ))}
    </div>
  );
}

export default Tabs;
